import { en } from './en.js';
import { mr } from './mr.js';
import type { TranslationKey } from './en.js';

export { en, mr };
export type { TranslationKey };

export const LANGUAGES = ['en', 'mr'] as const;
export type Language = (typeof LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'en';

export const LANGUAGE_LABELS: Record<Language, string> = {
  en: 'English',
  mr: 'मराठी',
};

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);
}

const DICTIONARIES: Record<Language, Partial<Record<TranslationKey, string>>> = { en, mr };

/**
 * Resolve a translation key. Mirrors the PHP `t()` helper: the requested
 * language wins, English fills any gap, and an unknown key returns itself so a
 * missing string is visible rather than silently blank.
 */
export function translate(lang: Language, key: TranslationKey | string): string {
  const dict = DICTIONARIES[lang] as Record<string, string | undefined>;
  return dict[key] ?? (en as Record<string, string | undefined>)[key] ?? key;
}

/** Bound translator for a language — `const t = translator('mr'); t('nav_home')`. */
export function translator(lang: Language): (key: TranslationKey | string) => string {
  return (key) => translate(lang, key);
}
